import ko from "lib/knockout";
import {SubcategoryList} from "./model/categories";

// component for SubcategoryList instance
// Input params: list instance or object with such properties
// - list {SubcategoryList}
ko.components.register('subcategories', {
	viewModel: {
		createViewModel: function (params) {
			if (params instanceof SubcategoryList) {
				params = {list: params};
			}
			return params;
		}
	},
	template: require('./templates/subcategories.html')
});


// WEBPACK FOOTER //
// ./modules/shop/common/components.js